export default __webpack_public_path__ + "static/site-preview-fec27ea6dc470ec5e1a1943af436dc5e.png";